import React from 'react';
import maskGroup from '../../assets/images/mask-group0.svg';
import { Link } from 'react-router-dom';

export const StatsComponent = () => {
  return (

    <div
        className="w-full h-full"
        style={{
          backgroundImage: `url(${maskGroup})`,
          backgroundColor: '#ffd700',
          backgroundBlendMode: 'multiply',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}
      >
    <section
      className="relative w-full py-16 px-4 bg-cover bg-center bg-no-repeat"
     
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-opacity-50" ></div>
      
      {/* Main Container */}
      <div className="relative max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-12"  style={{ backgroundImage: "url(../../assets/images/mask-group0.svg)" }}>
        {/* Left Section: Description */}
        <div className="flex flex-col gap-6 w-full lg:w-[530px] text-white" style={{ width: '620px' }}>
          <h2 className="text-[#ad2624] text-left font-roboto font-semibold text-[24px] leading-[36px]">
            Partner
          </h2>
          <h1 className="text-[#404040] text-left font-roboto font-black text-[50px] leading-[60px]">
            Seeking top-tier logistics and transportation services
          </h1>
          <p className="text-[#404040] text-left font-roboto text-[18px] leading-[27px] max-w-[525px]">
            We provide seamless, reliable, and cost-effective solutions to ensure your goods reach their destination safely and on time. With a robust network, advanced tracking systems, and a commitment to efficiency, we handle everything from freight forwarding to last-mile delivery. Trust us to streamline your supply chain with precision and professionalism.
          </p>
        </div>

        {/* Right Section: Button */}
        <Link to="/tracking">
          <button className="bg-[#ad2624] px-[10px] py-[3px] flex items-center justify-center gap-2 mx-auto w-[200px] hover:bg-[#ffd700] transition-colors duration-300 group" style={{paddingBottom:'9px', paddingTop:'9px'}}>
            <span className="text-[#ffffff] font-medium text-[20px] group-hover:text-[#111111]">Track now</span>
            <span className="text-[#ffffff] text-[40px] w-[20%] h-[20%] group-hover:text-[#111111] pb-[2.5px]">→</span>
          </button>
        </Link>
      </div>
    </section>

    </div>
  );
};

export default StatsComponent;